import { render } from "./TwitchAuth.vue?vue&type=template&id=29f84ea4&ts=true"
import script from "./TwitchAuth.vue?vue&type=script&lang=ts"
export * from "./TwitchAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__